<template lang="pug">
  .component-backoffice-merge-zone
    .row
      .column.small-12.large-6
        label How many geoJson to merge?
        input(type="number", v-model="numOfTextArea")
        pp {{numOfTextArea}}
    .row(v-if="numGeoJsonToMerge.length>0" v-for="n in numGeoJsonToMerge")
      .column
        label GeoJson{{n}}
        textarea(rows=10, v-model="geoJsonToMerge['geo'+n]" :name="'geo'+n")
    .row
      .colomn
        button.button(@click="mergeGeoJson" :disabled="disable") Merge
    .row(v-if="Object.keys(geoJsonToMerge).length !== 0 && spin" )
      .columns
        .row
          .column
            textarea(:value ='mergedGeoJson' id="geoJsonToCopy" rows=30)
        .row
          .column
            button.button(@click="copyToClipboard" ) Copy to clipboard

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'MergeZone',
    components: {},
    data() {
      return {
        numOfTextArea: 0,
        numGeoJsonToMerge: [],
        geoJsonToMerge: {},
        mergedGeoJson: '',
        geoJson: {},
        disable:'true',
        copyMerged: false,
        spin:false,
        validationJson: {}
      }
    },
    created() {

    },
    methods: {
      mergeGeoJson() {
        this.spin = false
        this.isJson(this.geoJsonToMerge)
        this.sanitazeNullValues(this.geoJsonToMerge)
        alert(JSON.stringify(this.validationJson))
        this.geoJson = {'geoJson' : this.geoJsonToMerge}
        KeplerBackofficeSdk.zones.mergeGeoJson(this.geoJson, (data) => {
          this.mergedGeoJson = JSON.stringify(data)
          this.spin=true
        })
      },
      copyToClipboard() {
        document.getElementById('geoJsonToCopy').select()
        document.execCommand("copy")
        MaggieHelper.notification('GeoJson copied to Clipboard')
      },
      sanitazeNullValues(obj) {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
            delete obj[key];
          }
        }
      },
      isJson(jsons) {
       // var valuesToCheck = Object.values(jsons)
        Object.keys(jsons).forEach(key => {
          try {
            const obj = JSON.parse( jsons[key]);
            if (obj && typeof obj === `object`) {
              this.validationJson[key] = 'OK'

            } else {
              this.validationJson[key] = 'WRONG'
            }
          } catch (err) {
            this.validationJson[key]  = 'error'
          }

        })
      }
    },
    watch: {
      numOfTextArea: function (newVal, oldVal) {
        this.mergedGeoJson=''
        this.spin = false
        if(newVal <= 0 || newVal === undefined || newVal === null) {
          this.geoJsonToMerge = {}
          this.disable = 'false'
        }
        if(this.numGeoJsonToMerge.length > 0) {
        if(newVal > oldVal) {
          var newGeoJsonToAdd = newVal - oldVal
        }
        else {
          var newGeoJsonToSub = oldVal - newVal
        }
        var lastGeoJson = this.numGeoJsonToMerge.length
        if(this.numGeoJsonToMerge.length < newVal) {
          for (var n = 1; n <= newGeoJsonToAdd; n++) {
            this.numGeoJsonToMerge.push(lastGeoJson + n)
          }
        }
        if(this.numGeoJsonToMerge.length > newVal) {
          for (var n = 1; n <= newGeoJsonToSub; n++) {
            this.numGeoJsonToMerge.pop()
          }
        }
        return this.numGeoJsonToMerge
        }
        for (var i = 1; i <= newVal; i++ ) {
          this.numGeoJsonToMerge.push(i)
        }
        this.disable = false
        return this.numGeoJsonToMerge.length
      }
    },
    computed: {},
    mounted() {}
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// MergeZone.vue?80d3ff88